export class PurchaseOrderMetals
{
    ptWeight: number;
    pdWeight: number;
    rhWeight: number;
    ptPrice: number;
    pdPrice: number;
    rhPrice: number;
    totalWeight: number;
    totalMonolithWeight: number;
    
    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}
